export const ROUTES_PATHS = {
  quit: "quit",
  main: "main",
  settings: "settings",
  settingsSBP: "sbp-settings",
  linking: "link-account",
  history: "history",
  operationsHistory: "operations-history",
  bankAccounts: "bank_accounts",
  withdraw: "withdraw",
  withdrawMe: "withdraw/me",
  withdrawMeBankSelection: "withdraw/me/bank_selection",
  withdrawMeConfirmation: "withdraw/me/confirmation",
  withdrawMeDetails: "withdraw/me/details",
  withdrawPushC2C: "withdraw/push-c2c/",
  auth: "auth",
  register: "register",
  registerOtp: "register/otp",
  registerIdentification: "register/identification",
  registerIdentificationCheck: "register/identification/check",
  transactionId: "transactionId",
  operationId: "operationId",
  comissionType: "comissionType",
  bankSelection: "bank_selection",
  bankAccountLinking: "bank_account_linking",
  successLinking: "success_linking",
  otp: "otp",
  password: "password",
  passwordConfirm: "password/confirm",
  identification: "identification",
  identificationCheck: "identification/check",
  check: "check",
  confirm: "confirm",
  authOtp: "auth/otp",
  sbpSettings: "sbp-settings",
  allowedBanks: "allowed-banks",
  confirmation: "confirmation",
  pushC2c: "push-c2c",
  me: "me",
  byCardNumber: "by_card_number",
  historyBeeline: "history-beeline",
  refill: "refill",
  refillLinkedAccount: "refill-linked-account",
  paymentToolsM2M: "PaymentToolsM2M",
  me2meAgreement: "me2me-agreement",
  error: "error",
  authError: "auth-error",
  incomeTransferRequestId: "incomeTransferRequestId",
  forbidden: "forbidden",
  limits: "limits",
  topUpMbankAccount: "top-up-mbank-account",
  topUpMbankAccountPayments: "top-up-mbank-account/payments",
  topUpMbankAccountRegistration: "top-up-mbank-account/registration",
  topUpMbankAccountRegistrationOtp: "top-up-mbank-account/registration/otp",
  topUpMbankAccountIdentification: "top-up-mbank-account/identification",
  topUpMbankAccountAuthorization: "top-up-mbank-account/auth",
  qr: "qr",
}

export const RUBLE = "₽"
export const RUBLE_TEXT = "рубль"

export const ROUTES = [
  {
    path: "/quit",
    title: "",
    shouldHideNavBar: true,
  },
  {
    path: "/main",
    title: "",
    shouldHideNavBar: false,
    prevPage: "/quit",
  },
  {
    path: "/limits",
    title: "Лимиты",
    shouldHideNavBar: false,
    prevPage: "/settings",
  },
  {
    path: "/settings",
    title: "Настройки",
    shouldHideNavBar: false,
    prevPage: "/main",
  },
  {
    path: "/sbp-settings",
    title: "Система быстрых платежей",
    shouldHideNavBar: false,
    prevPage: "/settings",
  },
  {
    path: "/allowed-banks",
    title: "Запрос перевода со своих счетов",
    shouldHideNavBar: false,
    prevPage: "/sbp-settings",
  },
  {
    path: `/${ROUTES_PATHS.topUpMbankAccountPayments}`,
    title: "Пополнить",
    shouldHideNavBar: false,
  },
  {
    path: `/${ROUTES_PATHS.topUpMbankAccountPayments}/bank`,
    title: "Банк списания",
    shouldHideNavBar: false,
  },
  {
    path: `/${ROUTES_PATHS.topUpMbankAccountPayments}/confirmation`,
    title: "Подтверждение",
    shouldHideNavBar: false,
  },
  {
    path: `/${ROUTES_PATHS.topUpMbankAccount}/absent-data`,
    shouldHideNavBar: true,
  },
  {
    path: `/${ROUTES_PATHS.topUpMbankAccount}/identification/success`,
    shouldHideNavBar: true,
  },
  {
    path: `/${ROUTES_PATHS.topUpMbankAccount}/identification/uprid`,
    title: "Паспорт гражданина РФ",
    shouldHideNavBar: false,
  },
  {
    path: `/${ROUTES_PATHS.topUpMbankAccountPayments}/success`,
    shouldHideNavBar: true,
  },
  {
    path: `/${ROUTES_PATHS.topUpMbankAccountPayments}/error`,
    shouldHideNavBar: true,
  },
  {
    path: "/history",
    title: "История операций",
    shouldHideNavBar: false,
  },
  {
    path: "/operations-history",
    shouldHideNavBar: false,
    prevPage: "/main",
  },
  {
    path: "/bank_accounts",
    title: "Привязанные счета",
    shouldHideNavBar: false,
  },
  {
    path: "/withdraw",
    title: "Перевести",
    shouldHideNavBar: false,
    prevPage: "/main",
  },
  {
    path: "/withdraw/me",
    title: "Перевести себе",
    shouldHideNavBar: false,
    prevPage: "/withdraw",
  },
  {
    path: "/push-c2c",
    title: "Кому",
    shouldHideNavBar: false,
    prevPage: "/main",
  },
  {
    path: "/withdraw/me/bank_selection",
    title: "Выбор банка",
    shouldHideNavBar: false,
  },
  {
    path: "/withdraw/me/confirmation",
    title: "Подтверждение",
    shouldHideNavBar: false,
  },
  {
    path: "/withdraw/me/details",
    shouldHideNavBar: true,
  },
  {
    path: "/auth",
    shouldHideNavBar: true,
  },
  {
    path: "/register",
    title: "Авторизация",
    shouldHideNavBar: false,
  },
  {
    path: "/register/otp",
    shouldHideNavBar: true,
  },
  {
    path: "/register/identification",
    title: "Упрощенная идентификация",
    shouldHideNavBar: false,
  },
  {
    path: "/register/identification/check",
    shouldHideNavBar: true,
  },
  {
    path: "/history-beeline",
    prevPage: "/main",
  },
  {
    path: "/refill",
    prevPage: "/main",
  },
  {
    path: "/me2me-agreement",
    prevPage: "/main",
  },
  {
    path: "/error",
    prevPage: "/main",
  },
  {
    path: `/${ROUTES_PATHS.authError}`,
    prevPage: "/main",
  },
  {
    path: `/${ROUTES_PATHS.qr}`,
    prevPage: "/main",
  },
]

export const PHONE_PREFIX = "+7"
export const QUERY_PARAMS_EXCHANGE_TOKEN_KEY = "token"
export const DATE_MONTH_FORMAT = "MMMM"
export const DATE_MOSCOW_TIMEZONE = "Europe/Moscow"
export const RNKO_BANK_ID = window.extended.REACT_APP_BANK_ID
export const PROVIDER_LIMIT = window.extended.REACT_APP_PROVIDER_LIMIT
